import SignupValidationAPI from '../../APIs/SignupAPI/SignupValidationAPI'
import router from '../../../router/index'

export const validationFour = {
    state: {
        getValidationFour: '',
        emailModifier: '',
        mailURL: '',
        error: '',
        notmatched: '',
        captchaErr: ''
    },
    actions: {
        validationFour({ commit }, userCredentials) {
            if (userCredentials.errors.length === 0) {
                delete userCredentials.errors
                // Send activation link to email
                SignupValidationAPI.validationFour(userCredentials)
                    .then((res) => {
                        // Will verify first if email exist
                        // First condition if verif modifier = 0, EMAIL ALREADY EXIST
                        if (res.data.VERIF_MODIFIER == 0) {
                            commit('VALIDATION_FOUR', {
                                ERR: res.data.ERR
                            })
                        }

                        // ELSE SEND ACTIVATION LINK
                        else {
                            if (res.data.CAPTCHA_ERR) {
                                commit('VALIDATION_FOUR', {
                                    CAPTCHA_ERR: res.data.CAPTCHA_ERR
                                })
                            } else {
                                commit('VALIDATION_FOUR', {
                                    EMAIL: res.data.EMAIL,
                                    MODIFIER: res.data.VERIF_MODIFIER,
                                    CAPTCHA_ERR: ''
                                })
                                router.push('/emailverif')
                            }
                            // returns entered EMAIL if true,EMAIL exist if false.
                        }
                        window.grecaptcha.reset()
                    })
                    .catch((error) => {
                        // console.error(error);
                        // Will verify first if email exist
                        // First condition if verif modifier = 0, EMAIL ALREADY EXIST
                        if (error.response.data.VERIF_MODIFIER == 0) {
                            commit('VALIDATION_FOUR', {
                                ERR: error.response.data.ERR
                            })
                        }

                        // ELSE SEND ACTIVATION LINK
                        else {
                            if (error.response.data.CAPTCHA_ERR) {
                                commit('VALIDATION_FOUR', {
                                    CAPTCHA_ERR: error.response.data.CAPTCHA_ERR
                                })
                            } else {
                                commit('VALIDATION_FOUR', {
                                    EMAIL: error.response.data.EMAIL,
                                    MODIFIER: error.response.data.VERIF_MODIFIER,
                                    CAPTCHA_ERR: ''
                                })
                                router.push('/emailverif')
                            }
                            // returns entered EMAIL if true,EMAIL exist if false.
                        }
                        window.grecaptcha.reset()
                    })
            } else {
                commit('VALIDATION_FOUR', {
                    ERR: userCredentials.errors[0]
                })
                window.grecaptcha.reset()
            }
        }
    },
    mutations: {
        VALIDATION_FOUR(state, displayOutput) {
            state.error = displayOutput.ERR ? displayOutput.ERR : ''
            state.getValidationFour = displayOutput.EMAIL ? displayOutput.EMAIL : ''
            state.emailModifier = displayOutput.MODIFIER ? displayOutput.MODIFIER : ''
            state.captchaErr = displayOutput.CAPTCHA_ERR ? displayOutput.CAPTCHA_ERR : ''
        },
        SET_ERROR_MESSAGE(state, param) {
            state.error = param
            state.captchaErr = param
        }
    },
    getters: {
        getValidationFour(state) {
            return state.getValidationFour
        },

        emailModifier(state) {
            return !!state.emailModifier
        },

        error(state) {
            return state.error
        },
        captchaErr(state) {
            return state.captchaErr
        }
    }
}
